<template>
    <div>
        <swb-query-sort-area ref="query_model_ctrl" :config="queryConfig" :popupHandler="popupHandler" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler" :eventHandler="queryEventHanlder"></swb-query-sort-area>
        <div class="table-layout">
            <el-table :data="orderServcEvalList" border style="width: 100%" class="mt30">
                <el-table-column label="服务项目名称" show-overflow-tooltip width="180" align="left">
                    <template slot-scope="rows">
                        <span>{{rows.row.title}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="catName" label="分类名称" width="180" align="left"></el-table-column>
                <el-table-column prop="engineerName" label="工程师名称" width="100" align="left"></el-table-column>
                <el-table-column prop="buyerName" label="评价商户" show-overflow-tooltip width="150" align="left"></el-table-column>
                <el-table-column prop="buyerShopName" label="评价机构" show-overflow-tooltip width="150" align="left"></el-table-column>
                <el-table-column prop="userName" label="评价人" width="100" align="left"></el-table-column>
                <!--<el-table-column prop="servcScore" label="服务评分" width="150" align="center">-->
                <!--<template slot-scope="rows">-->
                <!--<el-rate v-model="rows.row.servcScore" disabled></el-rate>-->
                <!--</template>-->
                <!--</el-table-column>-->
                <el-table-column prop="attitudeScore" label="态度评分" width="150" align="center">
                    <template slot-scope="rows">
                        <el-rate v-model="rows.row.attitudeScore" disabled></el-rate>
                    </template>
                </el-table-column>
                <el-table-column prop="skillsScore" label="技能评分" width="150" align="center">
                    <template slot-scope="rows">
                        <el-rate v-model="rows.row.skillsScore" disabled></el-rate>
                    </template>
                </el-table-column>
                <el-table-column prop="qualityScore" label="质量评分" width="150" align="center">
                    <template slot-scope="rows">
                        <el-rate v-model="rows.row.qualityScore" disabled></el-rate>
                    </template>
                </el-table-column>
                <el-table-column prop="avgScore" label="工程师平均评分" width="150" align="center">
                    <template slot-scope="rows">
                        <el-rate v-model="rows.row.avgScore" disabled></el-rate>
                    </template>
                </el-table-column>
                <el-table-column prop="comment" label="评价内容" width="180" show-overflow-tooltip align="left"></el-table-column>
                <el-table-column prop="accFileCount" label="附件数量" width="80" align="right"></el-table-column>
                <el-table-column prop="evalTagCount" label="标签数量" width="80" align="right"></el-table-column>
                <el-table-column prop="submitTime" label="提交时间" width="180" align="center"></el-table-column>
                <el-table-column prop="date" label="操作" width="80" align="left">
                    <template slot-scope="rows">
                        <a class="swb-btn-link" @click="showEvalInfo(rows.row.id)">查看</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
        <div class="form-toolbar" v-if="showBack">
            <button  @click="$router.back(-1)" class="swb-btn swb-btn-small swb-btn-primary">返回</button>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { getDefaultPageSizes } from '../../../src/app.conf'

    import servcDelivApi from '../../api/servcDeliv'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);
    import SwbServcEvalInfo from './ServcEvalInfo';
    Vue.regist(SwbServcEvalInfo);
    import SwbServcCategTree from '../categ/ServcCatTree';
    Vue.regist(SwbServcCategTree);

    let mockConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "valueType": "String",
                "label": "服务名称",
                "code": "title",
                "dataLabel": "text",
                "dataValue": "code",
                "basic": true
            },
            {
                "type": "Popup",
                "valueType": "Integer",
                "label": "分类名称",
                "code": "catId",
                "basic": true
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "提交时间",
                "code": "submitTime",
                "basic": true
            }
        ],
        "sortFields": []
    };

    export default {
        name: 'swb-servc-eval-list',
        path: '/servc/eval/list',
        desc: '服务评价列表',
        authen: false,
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                orderServcEvalList: [],
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                servcId: null,
                engineerId: null,
                workVoucherId: null,
                showBack: false
            }
        },
        created: function () {
            this.queryConfig = Utils.merge({}, mockConfigData);
            // 派工单列表跳转
            let workVoucherId = this.$route.query.workVoucherId || null;
            if(!Utils.isNoB(workVoucherId)) {
                this.workVoucherId = workVoucherId;
                this.showBack = true;
            }
            //
            this.pageSize = this.pageSizes.first();
            //
            this.getOrderServcEvalList();
        },
        methods: {
            popupHandler(fieldCode, curValue, curText){
                let self = this;
                Vue.$showDialog({
                    title: '服务分类信息',
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-servc-cat-tree :noPostFilters="true" :isClickEvent="false" :enableSearch = "enableSearch" ref="swb_servc_categ_tree"></swb-servc-cat-tree>' +
                    '</div>',
                    data: {
                        enableSearch: true
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_servc_categ_tree.getDlgResult() || {};
                        // 成功执行
                        if(result != null && result.type === 'info') {
                            let cat = result.data;
                            let query_model_ctrl = self.$refs['query_model_ctrl'];
                            let fieldInfo = {
                                catId: {
                                    value: cat.id,
                                    text: cat.name
                                }
                            };
                            query_model_ctrl.updateFields(fieldInfo);
                            return true;
                        } else {
                            this.$message.error(result.message);
                        }
                        return false;
                    },
                });
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getOrderServcEvalList();
            },
            queryEventHanlder: function (itemCode, eventName, itemValue, filterItems) {
                //
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.pageNumber = 1;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getOrderServcEvalList();
            },
            getOrderServcEvalList: function () {
                let self = this;
                let postData = {};
                //
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;

                if(!Utils.isNoB(self.workVoucherId)) {
                    postData.filterItems.workVoucherId = self.workVoucherId;
                }
                let theLoading = MsgBox.loading();
                servcDelivApi.getOrderServcEvalList(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        let rows = result.data.rows;
                        rows.forEach(function (el) {
                            let totalScore = el.totalScore;
                            let avgScore = Math.round(totalScore / 3);
                            el.avgScore = avgScore;
                        });
                        self.orderServcEvalList = rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showEvalInfo: function (evalId) {
                let theDlg = Vue.$showDialog({
                    title: "评价详情",
                    showCloseBtn: true,
                    width: 800,
                    height: 700,
                    okText: "知道了",
                    cancelVisible: false,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-servc-eval-info :evalId="evalId" ref="swb_servc_eval_info"></swb-servc-eval-info>' +
                    '</div>',
                    data: {
                        loading: false,
                        evalId: null,
                    },
                    okClicked: function () {
                        theDlg.close();
                    },
                    methods: {},
                    lifecycle: {
                        created: function () {
                            this.evalId = evalId;
                        }
                    }
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/ServcEvalList.vue